export default {
  toasts: {
    load_error: 'Facturile nu au putut fi încărcate.',
    action_error: 'Acțiunea a eșuat — vă rugăm încercați din nou.',
    finalized: 'Factură finalizată.',
    marked_paid: 'Factură marcată ca plătită.',
  },
  filters: {
    status: 'Filtrează după status',
  },
  volume_discount_badge: 'Reducere de volum aplicată ({{licenses}} licențe, {{percent}}%)',
  columns: {
    description: 'Factură',
    status: 'Status',
    total: 'Total',
    paid_at: 'Plătit la',
  },
  statuses: {
    pending: 'În așteptare',
    processing: 'În procesare',
    paid: 'Plătit',
    failed: 'Eșuat',
    refunded: 'Rambursat',
    partially_refunded: 'Rambursat parțial',
  },
  companies: {
    partner_level: 'Ajustări la nivel de partener',
    columns: {
      company: 'Restaurant',
      buckets: 'Poziții',
      amount: 'Sumă',
    },
  },
  buckets: {
    license_fees: 'Taxe de licență',
    service_fees: 'Taxe servicii',
    processing_fees: 'Taxe procesare',
    delivery_fees: 'Taxe livrare',
    gift_card_fees: 'Taxe card cadou',
    adjustments: 'Ajustări',
  },
  entries: {
    count: '{{count}} înregistrări',
    columns: {
      description: 'Înregistrare',
      occurred_at: 'Dată',
      amount: 'Sumă',
    },
  },
  incl_tax: 'incl. {{amount}} TVA',
  actions: {
    open_invoice_pdf: 'Descarcă factura (PDF)',
    open_hosted: 'Deschide factura pe Stripe',
    export_csv: 'Exportă CSV',
    finalize: 'Finalizează pe Stripe',
    mark_paid: 'Marchează ca plătit',
  },
  finalize: {
    title: 'Finalizați această factură pe Stripe?',
    description:
      'Finalizarea inițiază colectarea: cu o metodă de plată salvată, plata se procesează automat, altfel partenerul primește factura găzduită.',
    confirm: 'Finalizează',
  },
  mark_paid: {
    pushed_note:
      'Această factură există deja pe Stripe — schița va fi ștearsă (sau o factură finalizată marcată ca plătită în afara sistemului) pentru ca Stripe să oprească colectarea.',
    title: 'Marcați această factură ca plătită?',
    description:
      'Înregistrează o plată manuală (offline) de {{amount}}. Utilizați pentru transferuri bancare colectate în afara Stripe.',
    confirm: 'Marchează ca plătit',
  },
  settlement_badge: {
    paid: 'Cotă din venituri plătită: {{amount}}',
    other: 'Plată cotă din venituri {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Plăți cotă din venituri',
    retry: 'Reîncearcă',
    toasts: {
      load_error: 'Plățile nu au putut fi încărcate.',
      retry_error: 'Reîncercarea a eșuat — te rugăm să încerci din nou.',
      retry_paid: 'Cota din venituri a fost plătită.',
      retry_attempted: 'Reîncercarea a rulat — plata nu a fost încă efectuată, verifică statusul.',
    },
    columns: {
      period: 'Perioadă',
      amount: 'Sumă',
      status: 'Status',
      transfer: 'Transfer',
      paid_at: 'Plătit la',
      payout: 'Plată',
    },
    payout: {
      direct: '{{amount}}, fără conversie',
      direct_tooltip:
        'Suma datorată {{owed}}, convertită la 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} și trimisă ca atare: fără conversie Stripe, fără comision.',
      converted: 'Trimis {{sent}} → sosit {{arrived}}',
      expected: 'Trimis {{sent}} → așteptat {{arrived}}',
      fee: 'Comision de conversie Stripe {{amount}}',
      net: 'net {{amount}}',
      pending_details: 'Comisionul și suma netă apar după ce Stripe decontează transferul.',
      tooltip:
        'Datorat {{owed}}. Convertit la 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, trimis din soldul platformei în {{source_currency}} și convertit de Stripe la 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe reține {{fee_rate}}% la sosire.',
    },
    statuses: {
      pending: 'În așteptare',
      held: 'Reținut',
      processing: 'În procesare',
      paid: 'Plătit',
      failed: 'Eșuat',
      reversed: 'Reversat',
    },
    hold_reasons: {
      kyc_incomplete: 'Partenerul nu a finalizat încă verificarea contului de plată.',
      transfers_inactive: 'Contul de plată nu poate primi încă transferuri.',
      insufficient_platform_balance: 'Soldul platformei nu poate acoperi această plată acum.',
      manual_hold: 'Reținut manual.',
      missing_fx_rate: 'Nu există încă un curs de schimb salvat pentru moneda de plată. Se reîncearcă automat.',
      unsupported_payout_currency:
        'Stripe nu poate efectua această plată în moneda contului de plată din soldul platformei.',
      amount_too_small: 'Suma datorată este sub minimul Stripe pentru transferul în această monedă.',
    },
  },
};
